import { Request } from '@jfs/network'
import { MERGE_NB_CNB, PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { errorMessage } from '../../utils/string'
import { getAPIURL, getPaymentHeader } from '../config'
import { executeRequest } from './../../../../../libs/network/src/network'

const retInputData = (resArray: any) => {
  if (resArray && resArray.length > 0) {
    return resArray
      .map((item: any) => ({
        ...item,
        id: item.name,
        labelName: item.label,
        labelString: item.label,
        labelType: item.type,
        displayOrder: item.displayOrder === 'NA' ? 100 : Number(item.displayOrder),
      }))
      .sort((a: any, b: any) => {
        return a.displayOrder - b.displayOrder
      })
  }
  return []
}

const responseParser = (response: any, instrumentType: number) => {
  try {
    if (response.error) {
      const customError = {
        message: response?.error?.message ?? errorMessage.defautCatchMessage,
        code: response?.error?.code,
      }
      throw customError
    } else {
      const retData = response.map((item: any) => ({
        id: item.bankId,
        name: item.bankName,
        rank: item.rank,
        isPopular: item.popular,
        logo: item.imageUrl ? item.imageUrl : '',
        inputData: retInputData(item.instrumentMetaDataList),
        isCnb: MERGE_NB_CNB && instrumentType === PAYMENT_MODE_SUBTYPES.CORP_NB,
      }))
      return retData
    }
  } catch (error) {
    throw error
  }
}

/**
 * New PG
 * To return list of instruments
 * @param instrumentType
 * @param merchantId
 */
const getInstruments = (instrumentType: number, merchantId: number) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('instruments')}?instrumentType=${instrumentType}&merchantId=${merchantId}`,
    method: 'GET',
    headers: getPaymentHeader(),
  }

  return executeRequest(request)
    .then((resp) => {
      const { data } = resp
      return responseParser(data, instrumentType)
    })
    .catch((err) => {
      throw err
    })
}

export { getInstruments }
